// extracted by mini-css-extract-plugin
module.exports = {"highintensity":"#ce4a29","lowintensity":"#e9b424"};